import { render, staticRenderFns } from "./AcessoRestrito.vue?vue&type=template&id=5440879c&"
import script from "./AcessoRestrito.vue?vue&type=script&lang=js&"
export * from "./AcessoRestrito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports